<app-dine-content/>

<div class="d-grid col-8 col-sm-6 col-md-6 col-lg-4 mx-auto mt-2 mb-5">
  <button class="btn btn-lg btn-primary px-4 rounded-pill btn-lg" (click)="activeModal.close()"
          appRecordClickEvent="Continue"
          appRecordClickPage="Dine Club">Continue
  </button>
</div>
